import './TierList.css';
import { useUI } from '../../hooks/useUI';

const TierList = () => {
    const { userData } = useUI();

    return (
        <div className="tierlistPage">
            {userData.swap_tier.levels.map((tier, index) => (
                <div className="tierlistPage__content">
                    <div className="tierlistPage__titleContent">
                        <span className="tierlistPage__titleTextContent">Level {index + 1}</span>
                    </div>
                    <div className="tierlistPage__tableContent">
                        <div className="tierlistPage__amountContent">
                            <div className="tierlistPage__amountTilteContent">
                                <span className="tierlistPage__amountTilteTextContent">Min - max</span>
                            </div>
                            <input className="tierlistPage__amountInputContent" placeholder={`${tier.minamount} - ${tier.maxamount}`} disabled />
                        </div>
                        <div className="tierlistPage__rateContent">
                            <div className="tierlistPage__rateTilteContent">
                                <span className="tierlistPage__rateTilteTextContent">Rate</span>
                            </div>
                            <input className="tierlistPage__rateInputContent" placeholder={`1 BOM = ${tier.percent} XLM`} disabled />
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}

export default TierList;